import { render, staticRenderFns } from "./ErrorDetailsDialog.vue?vue&type=template&id=773000b9&scoped=true"
import script from "./ErrorDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorDetailsDialog.vue?vue&type=style&index=0&id=773000b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773000b9",
  null
  
)

export default component.exports